/* esm.sh - @noble/hashes@1.8.0/crypto */
var o=typeof globalThis=="object"&&"crypto"in globalThis?globalThis.crypto:void 0;export{o as crypto};
//# sourceMappingURL=crypto.mjs.map